'use strict';

import footerNav from './components/footer';

var loadjs = require('loadjs');
var mobile = require('is-mobile');

const dropdownEl = document.querySelectorAll('.rs-dropdown-toggle');
const popoverEl = document.querySelectorAll('.rs-popover');
const toolTipEL = $('[data-tippy-content]');
const youtubeEl = document.querySelectorAll('.rs-lazyYT');
const navTreeEl = $('.widget_nav_menu, .widget_product_categories, .widget-nav_menu');
const sidebarEL = $('.rs-sticky-left, .rs-sticky-right');
const popupEL = $('.rs-popup-image,.rs-popup-gallery,.rs-popup-video');
const isotopeEL = $('.rs-isotope__filter');
const meanMenuEL = $('.rs-mean-menu');
const accordionEL = $('.rs-accordion-container');
const swiperEL = $('.rs-swiper');
const wowEL = $('.wow');
const scrollSpyEL = $('.rs-scroll-nav');
const splideEL = document.querySelectorAll('.splide');

const wprs_get_assets_url = function($path) {
    const manifestObj = JSON.parse(wenpriseSettings.manifest);
    return manifestObj[$path];
};

if (dropdownEl.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/dropdown.js')], 'dropdown');
}

if (popoverEl.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/popover.js')], 'popover');
}

if (toolTipEL.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/tooltip.js')], 'tooltip');
}

if (youtubeEl.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/lazy-youtube.js')], 'lazy-youtube');
}

if (navTreeEl.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/nav-tree.js')], 'nav-tree');
}

if (sidebarEL.length > 0 && $(document).width() > 1024) {
    loadjs([wenpriseSettings.staticPath  + wprs_get_assets_url('/static/js/sticky-sidebar.js')], 'sticky-sidebar');
}

if (popupEL.length > 0) {
    loadjs([wenpriseSettings.staticPath  + wprs_get_assets_url('/static/js/magnific-popup.js')], 'magnific-popup');
}

if (isotopeEL.length > 0) {
    loadjs([wenpriseSettings.staticPath  + wprs_get_assets_url('/static/js/isotope.js')], 'isotope');
}

if (accordionEL.length > 0) {
    loadjs([wenpriseSettings.staticPath  + wprs_get_assets_url('/static/js/accordion.js')], 'accordion');
}

if (meanMenuEL.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/meanmenu.js')], 'meanmenu');
}

if (swiperEL.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/css/swiper.css'), wenpriseSettings.staticPath +  wprs_get_assets_url('/static/js/swiper.js')], 'swiper');
}

if (wowEL.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/wow.js')], 'wow');
}

if (scrollSpyEL.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/scrollspy.js')], 'scrollspy');
}

if (splideEL.length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/splide.js')], 'splide');
}

if ($('.rs-grid-filter').length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/mixitup.js')], 'mixitup');
}

if (document.querySelectorAll('.wp-block-woocommerce-product-categories').length > 0) {
    loadjs([wenpriseSettings.staticPath + wprs_get_assets_url('/static/js/block-tree.js')], 'block-tree');
}

if (!mobile()) {
    var ktTabButtons = document.querySelectorAll('.sub-menu .kt-tabs-title-list li a');
    ktTabButtons.forEach((thisElem) => {
        thisElem.addEventListener('mouseover', function(evt) {
            evt.preventDefault();
            const newActiveTabId = thisElem.getAttribute('data-tab');
            const tabWrap = thisElem.closest('.kt-tabs-wrap');
            window.KBTabs.setActiveTab(tabWrap, newActiveTabId);
        });
    });
}

footerNav();
